'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';

const MostViewed = createPage(
	() => import('@/features/discover/components/MostViewed'),
);

export default function MostViewPage() {
	return <MostViewed />;
}
